module.exports = __webpack_public_path__ + "img/item-1.ef25e7f6.png";